import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

import cookie from "react-cookies";

import { getLoggedProfile } from "../../actions/sessionAct";
import { getCarDetail } from "../../actions/carDetailAct";
// import { getCarDetail } from "../../model/car";
import { searchInHouse } from "../../model/common";

import { commonErr } from "../common/errors";
import { stypes } from "../common/common";
import { Loading } from "../common/loading";

import ImageLightBox from "../common/imagelightbox";
import { MessagePage } from "../common/messagebox";

import Login from "../login/login";
import SignUp from "../login/signup";

import CarDetailHeader from "./components/cardetailheader";
import CarDetailCover from "./components/cardetailcover";
import BookingSideBar from "./bookingsidebar";
import CarReviews from "./carreviews";
import CarReport from "./carreport";
import RelatedCars from "./relatedcars";
import CancelPolicy from "./components/cancelpolicy";

import { IcInstant, IcPhotos, IcIns } from "../common/svg";

import {
	InfoCar,
	OutsFeatures,
	Features,
	Description,
	Papers,
	Mortgates,
	Policy,
	Owner,
	CarMap,
} from "./components/infocar";

// import cover_default from "../../static/images/oldversion/img_landscape_2.jpg"

class CarDetailPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			relatedList: [],
			isMCalendar: false,
			showMapBox: false,
			showSignup: false
			
		};
		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}

	componentDidMount() {
		const carId = this.props.carId;
		const filter = this.props.carFinding.filter;

		const deliveryId =
			window.history.state !== null && window.history.state.deliveryId !== undefined
				? window.history.state.deliveryId
				: this.props.deliveryId
				? this.props.deliveryId
				: undefined;

		this.setState({
			deliveryId,
		});

		let ex = {
			carId: carId, 
			st: filter.startDate.valueOf(),
			et: filter.endDate.valueOf(),
			deliveryId: filter.deliveryId,
			vw: 'cd'
		}

		if (filter.lat && filter.lng) {
			// this.getCarDetail(
			// 	carId,
			// 	filter.lat,
			// 	filter.lng,
			// 	filter.startDate.valueOf(),
			// 	filter.endDate.valueOf(),
			// 	filter.deliveryId
			// );

			ex.lat = filter.lat
			ex.lng = filter.lng
		
			this.getCar(ex)
		} else if (filter.address && filter.address !== "") {
			searchInHouse(filter.address).then((response) => {
				if (response.data.error >= commonErr.SUCCESS && response.data.data && response.data.data.locations.length > 0) {
					const loc = response.data.data.locations[0];
					let latLng = { lat: loc.lat, lng: loc.lon };

					// this.getCarDetail(
					// 	carId,
					// 	latLng.lat,
					// 	latLng.lng,
					// 	filter.startDate.valueOf(),
					// 	filter.endDate.valueOf(),
					// 	filter.deliveryId
					// );
					
					ex.lat = latLng.lat
					ex.lng = latLng.lng

					this.getCar(ex)
				}
			});
		} else {
			this.getCar(ex)
			// this.getCarDetail(carId);
		}

		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VIEW_CAR_DETAIL", utmExt);
		window.gtag('event', "VIEW_CAR_DETAIL", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: {source: utmSrc}
		});
		window.fbq('track', "VIEW_CAR_DETAIL");
		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow()
	}

	componentDidUpdate(props) {
		const filter = props.carFinding.filter;
		const carId = props.carId;

		if (
			carId !== this.props.carId ||
			filter.address !== this.props.carFinding.filter.address ||
			filter.lat !== this.props.carFinding.filter.lat ||
			filter.lng !== this.props.carFinding.filter.lng
		) {

			let ex = {
				carId: this.props.carId, 
				st: filter.startDate.valueOf(),
				et: filter.endDate.valueOf(),
				deliveryId: filter.deliveryId,
				vw: 'cd'
			}

			if (filter.lat && filter.lng) {
			
				ex.lat = filter.lat
				ex.lng = filter.lng

				this.getCar(ex)
			} else if (filter && filter.address !== "") {
				searchInHouse(filter.address).then((response) => {
					if (
						response.data.error >= commonErr.SUCCESS &&
						response.data.data &&
						response.data.data.locations.length > 0
					) {
						const loc = response.data.data.locations[0];
						let latLng = { lat: loc.lat, lng: loc.lon };

						// this.getCarDetail(
						// 	carId,
						// 	latLng.lat,
						// 	latLng.lng,
						// 	filter.startDate.valueOf(),
						// 	filter.endDate.valueOf(),
						// 	filter.deliveryId
						// );
						ex.lat = latLng.lat
						ex.lng = latLng.lng
						this.getCar(ex)
					}

				});
			} else {
				// this.getCarDetail(this.props.carId);
				this.getCar(ex)
			}

			//GA
			const utmSrc = cookie.load("_utm_src") || "web_directly";
			const utmExt = cookie.load("_utm_ext") || "no_label";
			// window.ga("send", "event", utmSrc, "VIEW_CAR_DETAIL", utmExt);
			window.gtag('event', "VIEW_CAR_DETAIL", {
				event_category: utmSrc,
				event_label: utmExt,
				campaign: {source: utmSrc}
			});
			window.fbq('track', "VIEW_CAR_DETAIL");
		}
	}

	getCar = (ex) => {
		this.props.dispatch(getCarDetail(ex)).then(resp => {
			if (resp.action.payload.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: commonErr.SUCCESS
				})
			}
		})
	}

	checkWidthWindow = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true
			})
		} else {
			this.setState({
				isMCalendar: false
			})
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow()
	};



	// getCarDetail = (carId, lat, lng, st, et, deliveryId) => {
	

	// 	getCarDetail(
	// 		carId,
	// 		{
	// 			lat: lat,
	// 			lng: lng,
	// 			st: st,
	// 			et: et,
	// 			vw: "cd",
	// 		},
	// 		deliveryId,
	// 		this.stype
	// 	).then((resp) => {
	// 		if (resp.data.error >= commonErr.SUCCESS) {
	// 			this.setState({
	// 				err: commonErr.SUCCESS,
	// 				errMsg: resp.data.errorMessage,
	// 				carDetail: {
	// 					info: resp.data.data.car,
	// 					priceOrigin: resp.data.data.car.priceOrigin,
	// 					profiles: resp.data.data.profiles,
	// 					relatedCars: resp.data.data.cars,
	// 					reviews: resp.data.data.reviews,
	// 					moreReview: resp.data.data.moreReview,
	// 				},
	// 			});
	// 		} else {
	// 			this.setState({
	// 				err: resp.data.error,
	// 				errMsg: resp.data.errorMessage,
	// 			});
	// 		}
	// 	});
	// };

	isLogged = () => {
		return this.props.session.profile && this.props.session.profile.info && this.props.session.profile.info.uid;
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	showReportForm = () => {
		this.setState({
			showReportForm: true,
		});
	};

	closeReportForm = () => {
		this.setState({
			showReportForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	reportCarBtnClick = () => {
		if (!this.isLogged()) {
			this.showLoginForm();
		} else {
			this.showReportForm();
		}
	};

	updatePrice = (data) => {
		this.setState({
			carDetail: {
				info: data.car,
				priceOrigin: data.car.priceOrigin,
				profiles: data.profiles,
				relatedCars: data.cars,
				reviews: data.reviews,
				moreReview: data.moreReview,
			},
		});
	};

	// wd, after getprice in bookingslidebar, callback this to set state favbuttion
	setStateFavButtonWD = (favWD) => {
		this.setState({
			favWD,
		});
	};

	openMapBox = () => {
		this.setState({
			showMapBox: true 
		})
	}

	closeMapBox = () => {
		this.setState({
			showMapBox: false 
		})
	}

	render() {
		var content;
		const { err, carDetail, deliveryId, favWD, showReportForm, showLoginForm, isMCalendar } = this.state;

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <Loading />
		} else if (err === commonErr.SUCCESS && this.props.carDetail.detail) {
		
			const loggedProfile = this.props.session.profile.info;
			const { info, profiles, relatedCars, cars } = this.props.carDetail.detail;
			var ownerProfile;
			if (profiles && profiles.length > 0) {
				for (var i = 0; i < profiles.length; ++i) {
				if (profiles[i].uid === info.ownerId) {
						ownerProfile = profiles[i];
						break;
					}
				}
			}

			const relatedList = []
			if (relatedCars && relatedCars.length > 0 && cars) {
				for (let j=0; j < relatedCars.length; j++) {
					for (let k = 0; k < cars.length; k++) {
						if (relatedCars[j] === cars[k].id) {
							relatedList.push(cars[k])
						}
					}
				}
			}


			content = (
				<div className="detail-car">
					{/* <Cover car={info} showLoginForm={this.showLoginForm} isLogged={this.isLogged()} stype={this.stype} /> */}
					<CarDetailCover info={info} stype={this.stype} />

					<div className="m-container">
						<div className="detail-container">
							<div className="content-detail">
								<InfoCar
									info={info}
									isSD={this.isSD}
									showLoginForm={this.showLoginForm}
									isLogged={this.isLogged()}
									stype={this.stype}
									favWD={favWD}
								/>
							</div>
							<BookingSideBar
								closePopup={true}
								togglePopup={this.props.togglePopup}
								detail={this.props.carDetail.detail}
								owner={ownerProfile}
								showLoginForm={this.showLoginForm}
								loggedProfile={loggedProfile}
								updatePrice={this.updatePrice}
								setStateFavButtonWD={this.setStateFavButtonWD}
								stype={this.stype}
								deliveryId={deliveryId}
								onReportCar={this.reportCarBtnClick}
								isMCalendar={isMCalendar}
							/>
							<div className="content-detail">
								<div className="line-page" />
								<OutsFeatures info={info} />
								<div className="line-page" />
								<Description info={info} />
								<div className="line-page" />

								<Features info={info} />

								{info.features && info.features.length > 0 && <div className="line-page" />}

								{this.isSD && (
									<>
										<Papers info={info} />
										<Mortgates info={info} />
									</>
								)}
								<Policy policies={this.isSD ? info.notes : info.wdFull.policies} />

								<CancelPolicy car={true} />

								

								{this.isSD && <>
									<CarMap info={info} showMapBox={this.state.showMapBox} openMapBox={this.openMapBox} closeMapBox={this.closeMapBox} />
									<div className="line-page" />
								</>}

								<Owner isSD={this.isSD} ownerProfile={ownerProfile} />

								<CarReviews detail={this.props.carDetail.detail} />
							</div>
							<div className="clear"></div>
							{this.isLogged() && <CarReport show={showReportForm} hideModal={this.closeReportForm} car={info} />}
							<Login
								show={showLoginForm}
								showModal={this.openLoginForm}
								hideModal={this.closeLoginForm}
								openSignupForm={this.openSignupForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
							<SignUp
								show={this.state.showSignup}
								showModal={this.openSignupForm}
								hideModal={this.closeSignupForm}
								openLoginForm={this.openLoginForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
						</div>
					</div>
					{relatedList && relatedList.length > 0 && (
						<RelatedCars
							openNewWindow={true}
							isNewTab={false}
							cars={relatedList}
							togglePopup={this.props.togglePopup}
							stype={this.stype}
							showLoginForm={this.openLoginForm}
							isLogged={this.isLogged()}
						/>
					)}
				</div>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy thông tin."} />;
		}

		return (
			<>
				<Modal show={this.props.show} onHide={this.props.onHide} dialogClassName="modal-dialog modal-car-detail">
					<Modal.Header closeButton={true} closeLabel={""}>
						<CarDetailHeader stype={this.stype}/>
					</Modal.Header>
					<Modal.Body>{content}</Modal.Body>
				</Modal>
			</>
		);
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
		session: state.session,
		carDetail: state.carDetail
	};
}



CarDetailPopup = connect(mapState)(CarDetailPopup);

export default CarDetailPopup;
